import _ from "lodash";

export const checkCornerCollision = (checkedCorner, targetCords, bedWidth, bedHeight, areaObj) => {
    if (_validCorners(checkedCorner) && _validCorners(targetCords, true)) {
        let width = bedWidth;
        let height = bedHeight;

        if (areaObj.direction) {
            const isHorizontalList = areaObj.direction === "horizontal";
            width = Number(isHorizontalList ? areaObj.width : bedWidth);
            height = Number(!isHorizontalList ? areaObj.height : bedHeight);
            return _checkList({x: checkedCorner.x, y: checkedCorner.y, width, height}, targetCords);
        } else {
            const topLeftCorner = _checkCorner({
                x: checkedCorner.x, y: checkedCorner.y
            }, targetCords);
            const topRightCorner = _checkCorner({
                x: checkedCorner.x + width, y: checkedCorner.y
            }, targetCords);
            const bottomRightCorner = _checkCorner({
                x: checkedCorner.x + width,
                y: checkedCorner.y + height
            }, targetCords);
            const bottomLeftCorner = _checkCorner({
                x: checkedCorner.x, y: checkedCorner.y + height
            }, targetCords);

            return topLeftCorner || bottomRightCorner || bottomLeftCorner || topRightCorner;
        }
    }
    console.error("Wrong corner object", "checkedCorner", checkedCorner, "targetCords", targetCords);
    return -1;
};

export const getCurrentTransform = (scale) => {
    const text = scale;
    let obj = {
        x: 0,
        y: 0,
        k: 1,
    };

    if (_.isString(text) && text !== "") {
        const index = text.indexOf("scale");
        let tran = text.slice(9, index);
        let scale = text.slice(index + 5);
        tran = tran.replace(/[\(\)]/g, "");
        scale = scale.replace(/[\(\)]/g, "");
        const translate = tran.split(",");

        obj = {
            x: Number(translate[0]),
            y: Number(translate[1]),
            k: Number(scale),
        };
    }

    return obj;
};

const SPACING = 3;

// private
const _validCorners = (corner, haveBottomsCords) => {
    const validMainCords = corner && _.isObject(corner) && !_.isNil(corner.x) && !_.isNil(corner.y);

    if (validMainCords && haveBottomsCords) {
        const validBottomCords = corner && _.isObject(corner) && !_.isNil(corner.bottomX) && !_.isNil(corner.bottomY);

        return validMainCords && validBottomCords;
    }

    return validMainCords;
};

const _checkCorner = (checkedCorner, targetCords) => {
    const {x, y, bottomX, bottomY} = targetCords;

    return (x + SPACING <= checkedCorner.x && y + SPACING <= checkedCorner.y)
        && (bottomX + SPACING >= checkedCorner.x && bottomY + SPACING >= checkedCorner.y);
};

const _checkList = (checkedCorner, targetCords) => {
    const {x, y, bottomX, bottomY} = targetCords;
    const wList = {
        x: checkedCorner.x,
        y: checkedCorner.y,
        bottomX: checkedCorner.x + checkedCorner.width,
        bottomY: checkedCorner.y + checkedCorner.height
    };

    const corner1 = _checkCorner({x, y}, wList);
    const corner2 = _checkCorner({x: bottomX, y}, wList);
    const corner3 = _checkCorner({x: bottomX, y: bottomY}, wList);
    const corner4 = _checkCorner({x, y: bottomY}, wList);

    return corner1 || corner2 || corner3 || corner4;
};